import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getItemTagSerialNumbers } from '../../api/inventory/get-item-tag-serial-numbers'

const initialState = {
  isFetchingSerialNumbers: false,
  fetchSerialNumbersError: null,
  selectedItemTag: null,
  serialNumbers: [],
  selectedOrderItem: null,
  parentFeature: null,
}

/* Handler for making service call to fetch tags for a specific item */
export const fetchSerialNumbers = createAsyncThunk(
  'serialNumbers/fetchSerialNumbers',
  async (_args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      itemNumber: state.inventory.selectedInventoryItem.itemNumber.replaceAll('#', '%23'),
      tag: state.serialNumbers.selectedItemTag.tag,
      lot: state.serialNumbers.selectedItemTag.lot,
      location: state.serialNumbers.selectedItemTag.location,
      itemCode: state.serialNumbers.selectedItemTag.itemCode,
    }
    try {
      const response = await getItemTagSerialNumbers(request)
      return response?.data?.data.serialNumbers
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const serialNumbersSlice = createSlice({
  name: 'serialNumbers',
  initialState,
  reducers: {
    setSelectedItemTag(state, action) {
      state.selectedItemTag = action.payload
    },
    resetSelectedItemTag(state) {
      state.selectedItemTag = null
    },
    setSerialNumbers(state, action) {
      state.serialNumbers = action.payload
    },
    resetSerialNumbers(state) {
      state.serialNumbers = []
    },
    setSelectedOrderItem(state, action) {
      state.selectedOrderItem = action.payload
    },
    resetSelectedOrderItem(state) {
      state.selectedOrderItem = null
    },
    setParentFeature(state, action) {
      state.parentFeature = action.payload
    },
    resetParentFeature(state) {
      state.parentFeature = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSerialNumbers.pending, (state) => {
        state.isFetchingSerialNumbers = true
        state.serialNumbers = []
        state.fetchSerialNumbersError = null
      })
      .addCase(fetchSerialNumbers.fulfilled, (state, action) => {
        state.isFetchingSerialNumbers = false
        state.serialNumbers = action.payload
      })
      .addCase(fetchSerialNumbers.rejected, (state, action) => {
        state.isFetchingSerialNumbers = false
        state.fetchSerialNumbersError = action.payload
      })
      .addCase('itemTag/fetchItemTags/pending', (state) => {
        state.selectedItemTag = null
        state.serialNumbers = []
        state.selectedOrderItem = null
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const {
  setSelectedItemTag,
  resetSelectedItemTag,
  setSelectedOrderItem,
  resetSelectedOrderItem,
  setSerialNumbers,
  resetSerialNumbers,
  setParentFeature,
  resetParentFeature,
} = serialNumbersSlice.actions

export default serialNumbersSlice.reducer
